import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { getPriceByDiscount } from 'utils';
import { useTranslation } from 'react-i18next';

const ViewDetails = ({ name, price, format, tehnique, discount }) => {
  const { t } = useTranslation();
  return (
    <Grid direction="column" alignItems="center" justify="center" container>
      {name && (
        <Typography variant="subtitle2" component="h2">
          {name}
        </Typography>
      )}
      {tehnique && (
        <Typography variant="body2" color="textSecondary" component="p">
          {t('product-technique')} - {tehnique}
        </Typography>
      )}
      {format && (
        <Typography variant="body2" color="textSecondary" component="p">
          {t('product-format')} - {format}
        </Typography>
      )}
      <Grid direction="row" justify="center" alignItems="center" container>
        {price && (
          <Typography
            style={discount ? { textDecorationLine: 'line-through', display: 'inline' } : null}
            variant={discount ? 'button' : 'h6'}
            color={discount ? 'textSecondary' : 'error'}>
            {price} {t('product-currency')}
          </Typography>
        )}
        {discount && (
          <Typography style={{ paddingLeft: 10 }} variant="h6" color="error">
            {getPriceByDiscount(price, discount)} {t('product-currency')}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default ViewDetails;
